import React, { useContext, useEffect, useState } from 'react'
import { getAllOrders, getItemById } from '../../service/apiServise';
import OrderCard from './OrderCard';
import GuestCartCard from './GuestCartCard';
import UserContext from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import OrderFinish from './OrderFinish';
import './Order.css';
import { addItemToOrder, deleteOrderById, removeItemFromOredr, updateOrder } from '../../service/apiServise';
import { cartContext } from '../../contexts/CartContext';
import { OpenOrderContext } from '../../contexts/OpenOrderContext';
import ChocolateLoader from '../loading/ChocolateLoader';




function Order() {
  const { currentUser, isRequstToGetCurrentUserDone } = useContext(UserContext);
  const [orders, setOrder] = useState([]);
  const navigate = useNavigate();
  const [errorFromServer, setErrorFromServer] = useState('');
  const { cartItems, addToCart, decrementFromCart } = useContext(cartContext);
  const { syncFromOrders } = useContext(OpenOrderContext);
  const [guestCartDetails, setGuestCartDetails] = useState([]);
  // How many of the older ("previous") orders to show, below the current
  // one - starts small and grows via "עוד 5" instead of dumping the whole
  // history at once.
  const [visiblePreviousCount, setVisiblePreviousCount] = useState(5);
  // Without this, "אין הזמנות עדיין"/"העגלה שלך ריקה" showed during the
  // brief window before the fetch below actually resolves - indistinguishable
  // from genuinely having no orders, which is exactly what looked like a real
  // order having silently vanished right after placing it.
  const [isLoading, setIsLoading] = useState(true);



  const fetchOrders = async () => {


    try {
      const { data } = await getAllOrders();
      // Defensive - a "TypeError: .map is not a function" crashed this whole
      // page (before ErrorBoundary existed to catch it): orders.slice(0,-1)
      // on a non-array (this endpoint's declared return type is List<Order>,
      // so root cause is still server-side, not yet confirmed) returned
      // something itself missing .map further down, at render time.
      setOrder(Array.isArray(data) ? data : []);
      // Keep the product cards' "added" marks in step with what this page
      // just showed (items removed, order sent or deleted here).
      syncFromOrders(data);
    } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        setErrorFromServer(err.response.data);
      } if (err.code === "ERR_NETWORK") {
        setErrorFromServer("שגיאת רשת: בדוק/י את החיבור לאינטרנט ונסה/י שוב.");
      }
      setTimeout(() => {
        setErrorFromServer('');
      }, 5000);
    } finally {
      setIsLoading(false);
    }
  };

  // Guest view: there's no real order on the server to fetch (that's the
  // whole point - login is only required at final checkout), so instead of
  // calling getAllOrders() (which 401s and used to leave the page silently
  // showing "no orders yet"), build a cart view straight from CartContext's
  // local item ids. CartContext only stores raw ids, not item details, so
  // fetch each unique one via getItemById - the same approach Favorite.jsx
  // already uses to render a guest's favorites.
  const fetchGuestCartDetails = async () => {
    const uniqueIds = [...new Set(cartItems)];
    try {
      const items = await Promise.all(uniqueIds.map(id => getItemById(id)));
      const details = items.map(item => ({
        item,
        quantity: cartItems.filter(id => id === item.id).length,
      }));
      setGuestCartDetails(details);
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!isRequstToGetCurrentUserDone) {
      return;
    }
    if (currentUser) {
      fetchOrders();
    } else {
      fetchGuestCartDetails();
    }
  }, [currentUser, isRequstToGetCurrentUserDone, cartItems]);
const remove = async (id) => {
        try {
            await removeItemFromOredr(id )
            fetchOrders();
        } catch (err) {};
    }
    const add = async (id) => {


        try {
            await addItemToOrder(id )
            fetchOrders();
        } catch (err) {};
    }
    const deleteOrder = async (id) => {
        try {
            await deleteOrderById(id);
            fetchOrders();
        } catch (err) {
      if (err.response?.status == 400 || err.response?.status == 500) {
        setErrorFromServer(err.response.data);
      } if (err.code === "ERR_NETWORK") {
        setErrorFromServer("שגיאת רשת: בדוק/י את החיבור לאינטרנט ונסה/י שוב.");
      }
      setTimeout(() => {
        setErrorFromServer('');
      }, 5000);
    }
  };
    const sendOrder = async (note) => {
        try {
            await updateOrder(note);
            // No alert() here anymore - fetchOrders() below re-renders the
            // card with the new status ("התקבלה") right away, which is
            // already the confirmation that it went through.
            fetchOrders();
        }catch(err){
      if (err.response?.status == 400 || err.response?.status == 500) {
        setErrorFromServer(err.response.data);
      } if (err.code === "ERR_NETWORK") {
        setErrorFromServer("שגיאת רשת: בדוק/י את החיבור לאינטרנט ונסה/י שוב.");
      }
      setTimeout(() => {
        setErrorFromServer('');
      }, 5000);
    }
  };
  
  const lastOrder = orders[orders.length - 1];
  // orders comes back oldest-first (see getAllOrderByEmail) - that's still
  // what "the last one is the current/most-recent one" below relies on, but
  // everything *older* than that should read newest-on-top, not the reverse.
  const previousOrders = orders.slice(0, -1).reverse();
  const visiblePreviousOrders = previousOrders.slice(0, visiblePreviousCount);
  const hasMorePreviousOrders = previousOrders.length > visiblePreviousCount;

  const guestTotalPrice = guestCartDetails.reduce((sum, { item, quantity }) => sum + item.price * quantity, 0);

  if (!isRequstToGetCurrentUserDone || isLoading) {
    return <div className='center'><ChocolateLoader /></div>;
  }

  if (!currentUser) {
    // Guest: no server order exists yet, login is only required once they
    // actually want to send it - see GuestCartCard/mergeGuestDataToAccount.
    return (
      <div>
        {guestCartDetails.length === 0
          ? <h2>העגלה שלך ריקה</h2>
          : (
            <GuestCartCard
              items={guestCartDetails}
              totalPrice={guestTotalPrice}
              onIncrement={(id) => addToCart(id)}
              onDecrement={(id) => decrementFromCart(id)}
            />
          )}
      </div>
    );
  }

  return (
    <>
        <div>
          {orders.length === 0 ? <h2>אין הזמנות עדיין</h2> :
            <div>
              {lastOrder.status === "OPEN" ?
                <div>
                  <h2> הזמנות שלי</h2>
                  <OrderCard
                    key={lastOrder.id}
                    order={lastOrder}
                    remove={remove}
                    add={add}
                    deleteOrder={deleteOrder}
                    sendOrder={sendOrder}

                  />
                </div>
              :
               <OrderFinish
                    key={lastOrder.id}
                    order={lastOrder}

                  />
              }


              {visiblePreviousOrders.map((item) => (
                <div key={item.id}>
                  <div className='line'></div>

                  <OrderFinish
                    key={item.id}
                    order={item}

                  />

                </div>
              ))}
              {hasMorePreviousOrders && (
                <div className='load-more'>
                  <button className='btn' type='button' onClick={() => setVisiblePreviousCount(c => c + 5)}>
                    עוד 5 הזמנות
                  </button>
                </div>
              )}
            </div>

          }
        </div>

    </>
  )
}

export default Order